var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/**
 * 将老的单人榜单数据转化成新版单人榜单数据
 * @param entity
 * @returns
 */
function transformLegacy(entity) {
    var rank = entity.rank, point = entity.point, userid = entity.userid, nickname = entity.nickname, headphoto = entity.headphoto, rest = __rest(entity, ["rank", "point", "userid", "nickname", "headphoto"]);
    return {
        rank: rank || '',
        score: point || '0',
        detail: __assign({ userid: userid || '', nickname: nickname || '', avatar: headphoto || '' }, rest),
    };
}
/**
 * 榜单新老数据的适配器
 */
export function normalRankDataAdaptor(resp) {
    var list = resp.list, own = resp.own;
    return {
        list: list.map(function (item) { return transformLegacy(item); }),
        // 主要是为了兜底php的数据可能出问题
        own: Array.isArray(own) && own.length === 0 ? {} : transformLegacy(own),
    };
}
